import { operators as o, common as c } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';
const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};
const timeKeyFormat = '"01-02-2006"';

export default {
    name: 'ImportNPSPollResponseSummary',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build ({ npsReasonId = null, guideId, allPollIds = null, startTime, endTime = 'now()', last90Days = false }) {
        const filterByPollIds = [o.filter(allPollIds?.map((pollId) => `pollId == "${pollId}"`).join(' || '))];

        let timeSeries = {
            period: 'dayRange',
            first: startTime,
            last: endTime,
        };
        if (last90Days) {
            timeSeries = {
                period: 'dayRange',
                first: 'now()',
                count: -90,
            };
        }

        return o.pipeline(
            o.sources.pollEvents({
                guideId,
                timeSeries,
                blacklist: 'apply',
            }),
            o.filter(`pollId == "${npsReasonId}"`),
            o.fork(
                o.pipeline(o.count(null)),
                o.pipeline(
                    o.evaluate({ browserKeyTime: `formatTime(${timeKeyFormat}, browserTime)` }),
                    o.merge(
                        ['visitorId', 'browserKeyTime'],
                        o.mappings({
                            pollResponses: 'pollResponses',
                            pollResponseCount: 'pollResponseCount',
                            pollIds: 'pollIds',
                            pollTypes: 'pollTypes',
                        }),
                        o.pipeline(
                            o.sources.pollEvents({
                                guideId,
                                timeSeries,
                                blacklist: 'apply',
                            }),
                            ...(allPollIds ? filterByPollIds : []),
                            o.evaluate({ browserKeyTime: `formatTime(${timeKeyFormat}, browserTime)` }),
                            o.group(
                                ['pollId', 'visitorId', 'browserKeyTime'],
                                o.groupField('pollId', o.first('pollId')),
                                o.groupField('pollType', o.first('pollType')),
                                o.groupField('pollResponse', o.first('pollResponse')),
                            ),
                            c.nestedEval('pollResponseObj', {
                                pollResponse: 'pollResponse',
                                pollId: 'pollId',
                                pollType: 'pollType',
                            }),
                            o.group(
                                ['visitorId', 'browserKeyTime'],
                                o.groupField('pollResponseCount', o.count(null)),
                                o.groupField('pollResponses', o.list('pollResponseObj')),
                            ),
                        ),
                    ),
                    o.sort('browserTime'),
                    o.limit(1),
                    o.select({
                        pollId: 'pollId',
                        pollResponse: 'pollResponse',
                        response: 'response',
                        browserTime: 'browserTime',
                        visitorId: 'visitorId',
                        pollResponses: 'pollResponses',
                    }),
                ),
            ),
        );
    },
};
